import axios from "axios";

const API_ROOT =
  process.env.REACT_APP_API_ROOT_URL || "http://localhost:8000/api/v1";
const logApi = `${API_ROOT}/login`;

export const loginApi = async (frmDt) => {
  try {
    const { data } = await axios.post(logApi, frmDt);
    return data;
  } catch (err) {
    return err.response?.data || { status: "error", message: err.message };
  }
};

export const logOutApi = async (frmDt) => {
  try {
    const { data } = await axios.put(logApi, frmDt);
    return data;
  } catch (err) {
    return err.response?.data || { status: "error", message: err.message };
  }
};
